import { SettingsApi } from '@itsrever/rever-api'
import { apiClient } from '@/infrastructure/api'
import { DashboardUserPermissions } from '@/domain/dashboard-user'
import { toApiRole, toDashboardUsers } from './dto'

const settingsApi = new SettingsApi(undefined, undefined, apiClient)

// The endpoint defaults to the caller's own group, read from their token. That is the right
// answer for a merchant admin and the wrong one for REVER staff, whose group is "*": naming
// the ecommerce on screen asks for its group instead. The server authorizes the id, so a
// merchant admin still cannot reach outside their own group by passing one.
async function getDashboardUsers(ecommerceId?: string, signal?: AbortSignal) {
  const response = await settingsApi.findUsers({ ecommerceId }, { signal })
  return toDashboardUsers(response.data.users ?? [])
}

async function inviteDashboardUser(
  ecommerceId: string,
  email: string,
  permissions: DashboardUserPermissions
) {
  await settingsApi.createUser({
    pbCreateUserRequest: {
      // The server resolves the group from the id, so an invite cannot land in a group the
      // screen is no longer showing.
      ecommerce_id: ecommerceId,
      user: {
        email,
        role: toApiRole(permissions.role),
        assigned_warehouses: permissions.assignedWarehouses
      }
    }
  })
}

async function updateDashboardUser(
  id: string,
  permissions: DashboardUserPermissions,
  ecommerceId?: string
) {
  await settingsApi.updateUser({
    pbUpdateUserRequest: {
      id,
      ecommerce_id: ecommerceId,
      role: toApiRole(permissions.role),
      assigned_warehouses: permissions.assignedWarehouses
    }
  })
}

async function setDashboardUserAccessRevoked(
  id: string,
  revoked: boolean,
  ecommerceId?: string
) {
  await settingsApi.setUserBlocked({
    pbSetUserBlockedRequest: { id, blocked: revoked, ecommerce_id: ecommerceId }
  })
}

export default {
  getDashboardUsers,
  inviteDashboardUser,
  updateDashboardUser,
  setDashboardUserAccessRevoked
}
